import { isProductionBuild } from './general'
export function logDevelopment(msg) {
  if (!isProductionBuild() || localStorage.getItem("debug")) {
    console.log(`DEV`, msg)
  }
}
